import green from 'material-ui/colors/green'

export const styles = theme => ({
  actions: { float: 'right' },
  card: { minWidth: 350 },
  appTitle: {
    color: theme.palette.primary.contrastText,
    cursor: 'pointer',
    fontSize: 42,
    fontFamily: "'Monoton', cursive"
  },
  appTitleWrapper: {
    width: '100%',
    paddingLeft: theme.spacing.unit * 2,
    paddingTop: theme.spacing.unit,
    position: 'fixed',
    [theme.breakpoints.down('xs')]: { position: 'relative' },
    top: 0,
    left: 0
  },
  submit: { display: 'none' },
  title: {
    marginBottom: theme.spacing.unit * 2,
    color: theme.palette.primary.contrastText
  },
  welcome: {
    marginBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit,
    color: theme.palette.primary.contrastText
  },
  welcomeIcon: {
    backgroundColor: green[500],
    borderRadius: '50%',
    color: '#fff',
    fontSize: 200
  },
  wrapper: {
    background: theme.palette.primary.dark,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    minHeight: '100%',
    position: 'absolute',
    'overflow-y': 'auto',
    'overflow-x': 'hidden'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/styles/screens/Registration.js